// Language-prefixed URLs: Italian at root, other languages under /en, /de, /es, /fr.
export const PREFIX_LANGS = ["en", "de", "es", "fr"];
const PRIVATE = ["/admin", "/account", "/checkout", "/cart", "/club", "/order", "/review", "/reset-password"];

export const splitLang = (pathname = "/") => {
  const seg = pathname.split("/")[1];
  if (PREFIX_LANGS.includes(seg)) {
    const base = pathname.slice(seg.length + 1) || "/";
    return { lang: seg, base };
  }
  return { lang: null, base: pathname || "/" };
};

export const isLocalizable = (base) => !PRIVATE.some((p) => base === p || base.startsWith(p + "/"));

export const withLang = (base, lang) => (!lang || lang === "it" ? base : `/${lang}${base === "/" ? "" : base}`);

// Localizes an internal "to" (string or {pathname}) for the given language.
export const localizeTo = (to, lang) => {
  if (typeof to === "object" && to && typeof to.pathname === "string") return { ...to, pathname: localizeTo(to.pathname, lang) };
  if (typeof to !== "string" || !to.startsWith("/") || to.startsWith("//")) return to;
  const m = to.match(/^([^?#]*)(.*)$/);
  const { base } = splitLang(m[1] || "/");
  if (!isLocalizable(base)) return base + m[2];
  return withLang(base, lang) + m[2];
};
